import CoreBase from '../../../../../services/engines/CoreBase';

class OpenUrlHandler extends CoreBase {
    _name = 'OpenUrlHandler';

    /**
     * Handles jerny:openurl — opens a URL in a new tab.
     * Sandbox blocks window.open inside iframe — parent handles it here.
     * @param {MessageEvent} e
     */
    handle = (e) => {
        try {
            const url = e.data?.url;
            if (!url) return;

            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const openUrlHandler = new OpenUrlHandler();
export default openUrlHandler;
